import { supabase } from '../lib/supabase';
import { notificationService } from './notificationService';

export const formService = {
  async submitContactForm(formData) {
    try {
      const { data, error } = await supabase?.from('contact_submissions')?.insert([{
          name: formData?.name,
          email: formData?.email,
          phone: formData?.phone,
          country: formData?.country,
          project_type: formData?.projectType,
          budget_range: formData?.budgetRange,
          message: formData?.message,
          preferred_contact: formData?.preferredContact,
          status: 'new'
        }])?.select()?.single();

      if (error) {
        throw error;
      }

      // Send instant email notification
      try {
        await notificationService?.sendInquiryNotification('contact', formData);
      } catch (notifError) {
        console.error('Failed to send email notification:', notifError);
        // Don't fail the form submission if notification fails
      }

      return data;
    } catch (error) {
      console.error('Error submitting contact form:', error);
      throw new Error(error?.message || 'Failed to submit contact form');
    }
  },

  async submitConsultationForm(formData) {
    try {
      const { data, error } = await supabase?.from('consultation_bookings')?.insert([{
          name: formData?.name,
          email: formData?.email,
          service: formData?.service,
          message: formData?.message,
          selected_slot: formData?.selectedSlot,
          status: 'pending'
        }])?.select()?.single();

      if (error) {
        throw error;
      }

      // Send instant email notification
      try {
        await notificationService?.sendInquiryNotification('consultation', formData);
      } catch (notifError) {
        console.error('Failed to send email notification:', notifError);
        // Don't fail the form submission if notification fails
      }

      return data;
    } catch (error) {
      console.error('Error submitting consultation form:', error);
      throw new Error(error?.message || 'Failed to submit consultation booking');
    }
  },

  async submitPartnershipForm(formData) {
    const { data, error } = await supabase?.from('form_submissions')?.insert({
        form_type: 'partnership',
        name: formData?.contactPerson,
        email: formData?.email,
        phone: formData?.phone,
        subject: 'Partnership Inquiry',
        message: formData?.description,
        metadata: {
          companyName: formData?.companyName,
          partnershipType: formData?.partnershipType,
          industry: formData?.industry,
          website: formData?.website
        }
      })?.select()?.single();
    
    if (error) throw error;

    // Send email notification
    try {
      await notificationService?.sendEmailNotification({
        formType: 'partnership',
        name: data?.name,
        email: data?.email,
        phone: data?.phone,
        subject: data?.subject,
        message: data?.message,
        metadata: data?.metadata
      });
    } catch (emailError) {
      console.error('Failed to send email notification:', emailError);
    }

    return data;
  },

  async getAllSubmissions() {
    const { data, error } = await supabase?.from('form_submissions')?.select('*')?.order('created_at', { ascending: false });
    
    if (error) throw error;
    return data;
  },

  async updateSubmissionStatus(submissionId, status) {
    const { data, error } = await supabase?.from('form_submissions')?.update({ status })?.eq('id', submissionId)?.select()?.single();
    
    if (error) throw error;
    return data;
  },

  async deleteSubmission(submissionId) {
    const { error } = await supabase?.from('form_submissions')?.delete()?.eq('id', submissionId);
    
    if (error) throw error;
  },

  async submitNewsletterForm(email) {
    const { data, error } = await supabase?.from('form_submissions')?.insert({
        form_type: 'newsletter',
        name: 'Newsletter Subscriber',
        email: email,
        phone: '',
        subject: 'Newsletter Subscription',
        message: 'New newsletter subscription request',
        metadata: {
          subscriptionDate: new Date()?.toISOString()
        }
      })?.select()?.single();
    
    if (error) throw error;

    // Send email notification
    try {
      await notificationService?.sendEmailNotification({
        formType: 'newsletter',
        name: 'Newsletter Subscriber',
        email: data?.email,
        phone: '',
        subject: data?.subject,
        message: data?.message,
        metadata: data?.metadata
      });
    } catch (emailError) {
      console.error('Failed to send email notification:', emailError);
    }

    return data;
  }
};